module.exports = __webpack_public_path__ + "static/media/lk_puzzle_templo_gangaramaya.195cc6fc.jpg";